export const securitySetup = {
  junior: {
    requirements: [
      { name: 'Data Privacy Training', description: 'Complete data privacy and GDPR training', priority: 'high' },
      { name: 'Customer Data Access', description: 'Secure access to customer data and analytics', priority: 'high' },
      { name: 'Document Security', description: 'Secure handling of product documents and roadmaps', priority: 'medium' },
      { name: 'Communication Security', description: 'Secure communication practices with customers and stakeholders', priority: 'medium' }
    ],
    procedures: [
      { step: 'Complete privacy training', command: 'Complete company data privacy certification' },
      { step: 'Set up secure document sharing', command: 'Configure secure sharing for product documents' },
      { step: 'Enable 2FA on all accounts', command: 'Enable two-factor authentication on all product tools' },
      { step: 'Review data access policies', command: 'Understand customer data access policies and procedures' }
    ]
  },
  mid: {
    requirements: [
      { name: 'Product Security Reviews', description: 'Participate in product security reviews and assessments', priority: 'high' },
      { name: 'Compliance Management', description: 'Ensure product compliance with security standards', priority: 'high' },
      { name: 'Vendor Security Assessment', description: 'Assess security of third-party tools and vendors', priority: 'medium' },
      { name: 'Incident Response', description: 'Product security incident response procedures', priority: 'medium' }
    ],
    procedures: [
      { step: 'Conduct security reviews', command: 'Participate in regular product security assessments' },
      { step: 'Implement compliance checks', command: 'Set up compliance monitoring for product features' },
      { step: 'Vendor security evaluation', command: 'Evaluate security of product management tools' },
      { step: 'Document security requirements', command: 'Document security requirements in product specifications' }
    ]
  },
  senior: {
    requirements: [
      { name: 'Security Strategy', description: 'Define product security strategy and policies', priority: 'high' },
      { name: 'Privacy by Design', description: 'Implement privacy by design principles', priority: 'high' },
      { name: 'Regulatory Compliance', description: 'Ensure compliance with industry regulations', priority: 'high' },
      { name: 'Security Culture', description: 'Foster security culture within product teams', priority: 'medium' }
    ],
    procedures: [
      { step: 'Define security strategy', command: 'Develop comprehensive product security strategy' },
      { step: 'Implement privacy controls', command: 'Design privacy controls into product architecture' },
      { step: 'Compliance framework', command: 'Establish compliance framework for product development' },
      { step: 'Security training program', command: 'Develop security training for product teams' }
    ]
  }
};
